import { theme } from '@blueprint/ui';
import React from 'react';

const HideUniversalFooterStyle = `[data-testid="universal-footer"] { display: none; }`;

export const HideUniversalFooter = (
    <style
        data-testid="hide-universal-footer"
        dangerouslySetInnerHTML={{
            __html: HideUniversalFooterStyle
        }}
    />
);

export const HideUniversalFooterAtMobile = (
    <style
        data-testid="hide-universal-footer-mobile"
        dangerouslySetInnerHTML={{
            __html: `@media (max-width: ${theme.breakpoints[1]}px) {${HideUniversalFooterStyle}}`
        }}
    />
);
